import { render } from "./ArrowHorizontalIcon.vue?vue&type=template&id=e34455ba"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__